import { FC, useMemo } from 'react'
import * as styles from 'components/features/external/PublicSpendingTrend/LineChartPath.styl'
import { drawArea, drawLine, Point } from 'components/features/external/PublicSpendingTrend/helpers'
import { GRADIENT_COLORS } from 'components/features/pfm/LineChart/LineChart'
import { generate } from 'randomstring'

type LineChartPathProps = {
  points: Point[]
  zero: number
}

export const LineChartPath: FC<LineChartPathProps> = ({ points, zero }) => {
  const idPostfix = useMemo(generate, [])

  return (
    <>
      <defs>
        <linearGradient id={ `default-gradient${ idPostfix }` } x1='0' y1='0' x2='0' y2='1' spreadMethod='pad'>
          <stop offset='0%' stopColor={ GRADIENT_COLORS['you'] } stopOpacity='0.3' />
          <stop offset='100%' stopColor={ GRADIENT_COLORS['you'] } stopOpacity='0.1' />
        </linearGradient>
      </defs>
      <path
        fill={ `url(#default-gradient${ idPostfix })` }
        d={ drawArea(points, zero) }
      />
      <path
        d={ drawLine(points) }
        className={ styles.line }
      />
    </>
  )
}
